import styled from 'styled-components'

import { maxmedia, minmedia } from '../../styles/media-queries'
import { white, bordergray } from '../../styles/colors'

export const MiniContainer = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;

  ${minmedia.xmlarge`
    margin: 0;
    width: calc(45% - 1rem);
  `};
  ${maxmedia.medium`
    background: ${white};
    padding: 2rem 1rem;
    width: calc(100% - 2rem);
    margin: 0 auto;
    border-radius: 0.25rem;
    border: 1px solid ${bordergray};
  `};
`

export const ContentContainer = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  margin-top: 2rem;
  ${minmedia.xmlarge`
    margin-top: 0;
    width: calc(55% - 1rem);
  `};
`

export const Content = styled.div`
  margin-bottom: 4rem;

  ${maxmedia.medium`
    padding: 0 1rem;
  `};
`



// WEBPACK FOOTER //
// ./src/views/Contact/styles.js